// Generated by scripts/migrate/gen-from-live.py from https://www.dietz.eu/4-ag-alumni-tag-am-arnold-gymnasium-in-neustadt-bei-coburg/
// Source of truth is the LIVE page, not the original markdown scrape
// (which was incomplete: this content type was missed entirely, and
// several pages were captured as summaries rather than verbatim copy).
import type { PageEntry } from "@/content/schema";

export const p4AgAlumniTagAmArnoldGymnasiumInNeustadtBeiCoburgDE: PageEntry = {
  id: "post.4-ag-alumni-tag-am-arnold-gymnasium-in-neustadt-bei-coburg",
  locale: "de",
  slug: "4-ag-alumni-tag-am-arnold-gymnasium-in-neustadt-bei-coburg",
  seo: {
    title: "4. AG-Alumni-Tag am Arnold-Gymnasium in Neustadt bei Coburg | Dietz GmbH",
    description: "4. AG-Alumni-Tag am Arnold-Gymnasium in Neustadt bei Coburg",
  },
  type: "post",
  h1: "4. AG-Alumni-Tag am Arnold-Gymnasium in Neustadt bei Coburg",
  blocks: [
    { kind: "heading", level: 2, text: "4. AG-Alumni-Tag am Arnold-Gymnasium in Neustadt bei Coburg" },
    { kind: "paragraph", text: "Auf dem Alumni-Tag haben wir an unserem Messestand über unser Unternehmen informiert und dabei unsere Ausbildungsmöglichkeiten und Dualen Studiengänge vorgestellt. Im Vorfeld hatte bei uns im Haus ein Bewerbertraining stattgefunden, das bei den Schülern sehr gut ankam. Nebenbei konnten sie an einem Gewinnspiel teilnehmen, bei dem sie die Anzahl winziger Druckfedern in einem Beutel schätzen sollten. Die glückliche Gewinnerin, die mit ihrer Schätzung so gut wie richtig lag, darf sich nun über zwei Freikarten zu einem Heimspiel des HSC 2000 Coburg freuen." }
  ],
};
